<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listCivilStatuss"
        :title-table="$t('Civil Status')"
        module="civilStatusSettingsModule"
        sort-name="nome"
        :add-permission="'ROLE_ESTADO_CIVIL_INSERIR'"
        :view-permission="'ROLE_ESTADO_CIVIL_CONSULTAR'"
        :edit-permission="'ROLE_ESTADO_CIVIL_ATUALIZAR'"
        :delete-permission="'ROLE_ESTADO_CIVIL_DELETAR'"
        @add="addNew"
        @edit="edit"
      />
      <FormCivilStatus
        v-else
        @cancelar="cancelar"
      />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'
import FormCivilStatus from './forms/FormCivilStatus.vue'

export default {
  components: {
    BRow,
    BCol,
    TableComponents,
    FormCivilStatus,
  },
  computed: {
    ...mapState('civilStatusSettingsModule', {
      listCivilStatuss: state => state.listCivilStatuss,
    }),
  },
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: 'Id',
          field: 'id',
        },
        {
          label: 'Descrição',
          field: 'nome',
        },
        {
          label: 'Ativo',
          field: 'ativo',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
    }
  },
  methods: {
    addNew() {
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch(
        'civilStatusSettingsModule/prepareToEditCivilStatus',
        data,
      )
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
    },
  },
}
</script>
